/**
 * One-shot record that an activity-bar click is opening a view that was not
 * already active (见 21).
 *
 * The value is a generation, not a boolean, so a view can tell a new click
 * from one it has already handled. Re-activation of an already-active item
 * does not bump it; that gesture stays on `registerRailActivation`.
 */
const generationByView = new Map<string, number>();
let nextGeneration = 0;

export function markActivityBarOpen(viewId: string): void {
  nextGeneration += 1;
  generationByView.set(viewId, nextGeneration);
}

export function activityBarOpenGeneration(viewId: string): number {
  return generationByView.get(viewId) ?? 0;
}
